<template>
	<div class="sidebar-datetimepicker">
		<div class="row">
			<div class="col-12">
				<erco-date-time-picker :datetime="data.datetime"
				                       :fallbackDatetime="now"
				                       @change="handleDateTimePickerChange">
				</erco-date-time-picker>
			</div>
		</div>
	</div>
</template>

<script>
	import moment from 'moment';
	import Const from '@/constants';

	import ErcoDateTimePicker from '@/components/molecules/ErcoDateTimePicker';

	export default {
		name: 'ErcoSidebarDateTimePickerMolecule',

		props: {
			data: {
				type: Object,
				default: (function dataDefault() {
					return {
						datetime: new Date(),
					};
				}()),
			},
		},

		data() {
			return {
				now: new Date(),
			};
		},

		methods: {
			handleDateTimePickerChange(dateTime) {
				const dateTimeFormat = Const.DATETIMEFORMAT;
				const momDateTime = moment(dateTime, dateTimeFormat);
				const newSidebarContext = Object.assign({}, this.$store.state.sidebar.context);
				newSidebarContext.value = momDateTime.format(dateTimeFormat);

				this.$store.dispatch('updateSidebar', { context: newSidebarContext });
			},
		},

		components: {
			ErcoDateTimePicker,
		},
	};
</script>

<style lang="scss">

	.sidebar-datetimepicker {
		padding: 1.5rem 0.5rem;
	}

</style>



// WEBPACK FOOTER //
// DateTimePicker.vue?c8f41260